import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { manifesto } from '../data/mock';

const Manifesto = () => {
  return (
    <section id="manifesto" className="py-32 px-6 bg-black relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-20 right-10 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-20 text-center"
        >
          <h2 className="text-6xl md:text-7xl font-black text-white mb-6">
            Nuestro Manifiesto
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Los principios que nos hacen diferentes
          </p>
        </motion.div>

        <div className="space-y-24">
          {manifesto.map((item, index) => (
            <ManifestoItem key={item.number} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

const ManifestoItem = ({ item, index }) => {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: index % 2 === 0 ? -60 : 60 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="grid md:grid-cols-12 gap-8 items-center"
    >
      <div className={`md:col-span-3 ${index % 2 === 0 ? 'md:order-1' : 'md:order-2'}`}>
        <motion.div
          className="text-[140px] md:text-[180px] font-black leading-none bg-gradient-to-br from-orange-400 via-amber-400 to-orange-500 bg-clip-text text-transparent"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={inView ? { scale: 1, opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {item.number}
        </motion.div>
      </div>

      <div className={`md:col-span-9 ${index % 2 === 0 ? 'md:order-2' : 'md:order-1'}`}>
        <motion.h3
          className="text-4xl md:text-5xl font-bold text-white mb-6"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          {item.title}
        </motion.h3>
        <motion.p
          className="text-xl text-gray-400 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          {item.description}
        </motion.p>
      </div>
    </motion.div>
  );
};

export default Manifesto;